/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ct_Label_DefaultInputs */

const en_ct_label_default = /** @type {(inputs: Ct_Label_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let's build`)
};

const ar_ct_label_default = /** @type {(inputs: Ct_Label_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لنبدأ`)
};

const bn_ct_label_default = /** @type {(inputs: Ct_Label_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চলুন বানাই`)
};

const de_ct_label_default = /** @type {(inputs: Ct_Label_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lass uns bauen`)
};

const es_ct_label_default = /** @type {(inputs: Ct_Label_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construyamos`)
};

const fr_ct_label_default = /** @type {(inputs: Ct_Label_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construisons`)
};

const pt_ct_label_default = /** @type {(inputs: Ct_Label_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vamos construir`)
};

const zh_ct_label_default = /** @type {(inputs: Ct_Label_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让我们构建`)
};

const tr_ct_label_default = /** @type {(inputs: Ct_Label_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haydi inşa edelim`)
};

const ru_ct_label_default = /** @type {(inputs: Ct_Label_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Давайте построим`)
};

const pl_ct_label_default = /** @type {(inputs: Ct_Label_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budujmy`)
};

/**
* | output |
* | --- |
* | "Let's build" |
*
* @param {Ct_Label_DefaultInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const ct_label_default = /** @type {((inputs?: Ct_Label_DefaultInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ct_Label_DefaultInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ct_label_default(inputs)
	if (locale === "bn") return bn_ct_label_default(inputs)
	if (locale === "de") return de_ct_label_default(inputs)
	if (locale === "es") return es_ct_label_default(inputs)
	if (locale === "fr") return fr_ct_label_default(inputs)
	if (locale === "pt") return pt_ct_label_default(inputs)
	if (locale === "zh") return zh_ct_label_default(inputs)
	if (locale === "tr") return tr_ct_label_default(inputs)
	if (locale === "ru") return ru_ct_label_default(inputs)
	if (locale === "pl") return pl_ct_label_default(inputs)
	return en_ct_label_default(inputs)
});